// 액션 타입 정의
export const UPDATE = 'UPDATE';

// 액션 생성자 정의
export const basketUpdate = () => ({
    type: UPDATE
});